import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { amount, JobDto, JobLineDto, JobVat, ModelMasterDto, ResourceMasterDto } from "@shared/models";
import { switchMap } from "rxjs/operators";
import { JobService, ProductSettingService } from "../../common/services";

@Component({
  selector: "abi-invoice",
  templateUrl: "./invoice.component.html",
  styleUrls: ["./invoice.component.scss"]
})
export class InvoiceComponent implements OnInit {
  @Input() job: JobDto;
  @Input() resource: ResourceMasterDto;
  @Input() model: ModelMasterDto;
  @Input() useRouting = true;

  invoiceNumber: string;
  invoiceDate: string;
  lines: JobLineDto[];
  showVat = true;

  companyName: string;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  addressLine4: string;
  addressLine5: string;
  postalCode: string;
  countryCode: string;
  websiteUrl: string;
  registrationNumber: string;
  vatNumber: string;
  tenant: string;
  telephone: string;
  email: string;

  loading = true;

  constructor(private productSettings: ProductSettingService, private route: ActivatedRoute,
              private jobService: JobService) {
    if (this.productSettings.hasSetting("VatRate")) {
      this.showVat = this.productSettings.numericValue("VatRate") > 0;
    }
    JobVat.vatRate = productSettings.numericValue("VatIncluded") ? 0.0 : 0.15;

    this.tenant = route.snapshot.paramMap.get("tenant");
  }

  ngOnInit() {
    if (this.useRouting) {
      this.route.paramMap.pipe(
        switchMap((params: ParamMap) => this.jobService.getJob(params.get("jobId"), params.get("check"))))
        .subscribe((job: JobDto) => {
          this.job = job;
          this.invoiceNumber = this.route.snapshot.paramMap.get("invoice");
          this.lines = job.lines.filter(l => l.invoice === this.invoiceNumber);
          this.loadCompanyInfo();
          this.invoiceDate = this.lines[0].fields[4] || this.lines[0].requested.format("yMMdd");
          if (!job.machine.model) {
            this.jobService
              .getModel(job.machine.modelId).toPromise().then(m => {
                this.model = m;
                job.machine.model = m;
              });
          }
        });
    } else {
      this.loadCompanyInfo();
    }
  }

  private loadCompanyInfo(): void {
    const date: Date =  this.lines ? this.lines[0].requested : new Date(); // new Date(2019,11,11);//

    this.productSettings
    .getCompanyInfo(date)
    .toPromise()
    .then(info => {
      this.tenant = info.id;
      this.companyName = info.name;
      this.addressLine1 = info.lines[0];
      this.addressLine2 = info.lines[1];
      this.addressLine3 = info.lines[2];
      this.addressLine4 = info.lines[3];
      this.addressLine5 = info.lines[4];
      this.postalCode = info.postalCode;
      this.countryCode = info.country;
      this.websiteUrl = info.website;
      this.registrationNumber = info.registrationNumber;
      this.vatNumber = info.vatNumber;
      this.email = info.emailAddress;
      this.telephone = info.telephone;

      this.loading = false;
    });

  }

  public asTextBlock(): string {
    let result = this.companyName + "\n";


    if (this.addressLine1) {
      result += this.addressLine1 + "\n";
    }
    if (this.addressLine2) {
      result += this.addressLine2 + "\n";
    }
    if (this.addressLine3) {
      result += this.addressLine3 + "\n";
    }
    if (this.addressLine4) {
      result += this.addressLine4 + "\n";
    }
    if (this.postalCode) {
      result += this.postalCode;
    }
    // if (this.addressLine5)
    //   result += this.addressLine5 + '\n';

    return result;
  }

  get total(): number {
    return this.lines ? this.lines.reduce((amt: number, line) => amt + amount(line), 0) : 0;
  }

  get vat(): number {
    const total = this.total;
    return total / 1.15 * 0.15;
  }

  get header(): string {
    return this.total > 0 ? "INVOICE" : "CREDIT NOTE";
  }

  hasDealerInfo() {
    return this.job?.machine?.dealerBranchId
    || this.job?.dealerContact?.companyName || this.job?.dealerContact?.firstName || this.job?.dealerContact?.lastName;
  }
}
